import './desktop-sticky-aside';
import './headoffice-message';
import './m2g-modal';
import './m2g-order-section.v2';
import './m2g-scrollspy';
